


export default function EmptyState({children}) {
    return (
        <div style={{
            padding: '15px',
            textAlign: 'center'
        }}>
            {children}
        </div>
    )
}